<template>
  <div class="oss-preview-img">
    <p v-if="uploadList.length !== 0" class="info-text">担保物图片：</p>
    <div
      class="demo-upload-list"
      v-for="(item, index) in uploadList"
      :key="index"
    >
      <img :src="item.url" />
      <div class="demo-upload-list-cover">
        <i class="el-icon-view" @click="handleView(item.url)"></i>
      </div>
    </div>
    <!-- Dialog -->
    <el-dialog title="查看大图" :visible.sync="bigImages.visible" width="60%">
      <img :src="bigImages.url" alt="查看大图" style="width: 100%;" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "oss-preview-img",
  props: {
    // 图片id列表
    images: {
      type: Array || null,
      default: () => []
    }
  },

  computed: {
    // 开发环境 | 正式环境
    isDev() {
      return process.env.NODE_ENV === "development";
    }
  },

  watch: {
    images: {
      immediate: true,
      deep: true,
      handler(data) {
        this.getUploadedImages(data);
      }
    }
  },

  data() {
    return {
      // 图片列表
      uploadList: [],

      // 查看大图
      bigImages: {
        visible: false,
        url: ""
      }
    };
  },

  methods: {
    // 获取上传成功的图片
    getUploadedImages(imgs) {
      let uploadList = [];
      imgs.forEach(item => {
        let uuid = typeof item === "string" ? item : item["uuid"];
        const url = this.getUploadedImageUrl(uuid);
        uploadList.push({
          status: "finished",
          url
        });
      });
      this.uploadList = uploadList;
    },

    // 获取上传成功的图片线上路径
    getUploadedImageUrl(uuid) {
      const config = this.$config.ossCfg[
        this.isDev ? "collateralDev" : "collateral"
      ];
      const oss = new this.$oss(config);
      const url = oss.signatureUrl(uuid);

      return url;
    },

    /**
     * 查看大图
     * @param {url} 图片地址
     */
    handleView(url) {
      this.bigImages.visible = true;
      this.bigImages.url = url;
    }
  }
};
</script>
